export default __webpack_public_path__ + "static/media/mic.dc73b19b.png";